module.exports = __webpack_public_path__ + "static/img/cross-icon.8445aee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cross-icon.png
// module id = jZpf
// module chunks = 1